import axios from "axios";
import store from "../store/index";
import { Loading, Message } from "element-ui";
import path from "./url";
import _ from "loadsh";
import router from "../src/router/index";
let loading;
let requesting = false;
function showLoading(target) {
  if (!requesting) {
    requesting = true;
    loading = Loading.service({
      lock: true,
      text: "Loading...",
      background: "rgba(255,255,255,0.4)",
      target: "#app"
    });
  }
}

function hideLoading() {
  if (requesting) {
    requesting = false;
    loading.close();
  }
}
const $http = axios.create({
  baseURL: path.base,
  responseType: "json",
  transformResponse: [
    function(data) {
      return data;
    }
  ],
  timeout: 30000, // request timeout, default is 30s.
  withCredentials: false
});
$http.interceptors.request.use(
  config => {
    showLoading();
    const token = store.state.token;
    config.headers["x-trace-id"] = token;
    if (config.url.indexOf("?") > -1) {
      config.url = `${config.url}&token=${token}`;
    } else {
      config.url = config.url + "?token=" + token;
    }






    // config.url = config.url + "?token=" + token;
    return config;
  },
  error => {
    hideLoading();
    if (error.data) {
      errorHandle(error.data.code, error.data);
    }
    return Promise.reject(error);
  }
);
const toLogin = () => {
  router.replace({
    path: "/login/admin",
    query: {
      redirect: router.currentRoute.fullPath
    }
  });
};
$http.interceptors.response.use(
  response => {
    hideLoading();
    if (
      response.data &&
      response.data.data &&
      response.data.data.code &&
      response.data.data.code == "00B"
    ) {
      // 登录失效
      toLogin();
    }
    if (!response.data.code && !response.data.data) {
      //临时
      if (response.status === 200) {
        //成功
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }
    if (!response.data.code && response.data.data) {
      if (response.data.data.code == "00B") {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
      }
    }
    if (response.data.code === "40000" || response.data.data.code === "40000") {
      return Promise.resolve(response.data.data.data);
    } else {
      if (response.data && response.data.data && response.data.data.msg) {
        Message({
          showClose: true,
          message: response.data.data.msg,
          type: "error"
        });
      }
    }
    return Promise.reject(response.data.data);
    // status:200, normal
  },
  error => {
    hideLoading();
    if (error.data) {
      errorHandle(error.data.code, error.data.data);
    }

    return Promise.reject(error);
  }
);
const errorHandle = (status, other) => {
  //状态码判断
  switch (status) {
    case 401:
      toLogin();
      break;
    case 403:
      Message({
        showClose: false,
        message: "登录过期，请重新登录",
        type: "error"
      });
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      store.commit("loginSuccess", null);
      setTimeout(() => {
        toLogin();
      }, 1000);
      break;
    case 404:
      Message({
        showClose: false,
        message: "网络请求不存在",
        type: "error"
      });
      break;
    default:
      Message({
        showClose: true,
        message: other,
        type: "error"
      });
    /*   Message({
        showClose: false,
        message: error.response.data.message,
        type: "error"
      }); */
  }
};
export default $http;



//////////////////
// WEBPACK FOOTER
// ./api/http.js
// module id = MZKR
// module chunks = 28